import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { SharedService } from '../../../../Services/shared.service';
import { environment } from '../../../../../environments/environment';
import { Location } from '@angular/common';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
const PdfBreakpoints = {
  xs: 490,
  sm: 560,
  md: 610,
  lg: 660,
  xl: 740,
  xxl: 830
};

@Component({
  selector: 'app-e-book',
  standalone: true,
  imports: [CommonModule, NgxExtendedPdfViewerModule, RouterModule],
  templateUrl: './e-book.component.html',
  styleUrls: ['./e-book.component.css']
})
export class EBookComponent implements OnInit {
  path: string = '';
  chapters: any[] = [];
  ChapterList:any[] = [];
  selectedChapterUrl: SafeResourceUrl | null = null; 
  activeChapterIndex = 0;
  selectedPdf: string = '';
  zoom: any = 'page-fit';
  pageViewMode: any = 'book';
  BookName: string = '';
  constructor(private route: ActivatedRoute, private _svc: SharedService ,public location: Location ,private sanitizer: DomSanitizer) { }
  
  
ngOnInit(): void {
  debugger
  const pdfBaseUrl = environment.pdfBaseUrl;
  this.route.queryParamMap.subscribe(params => {
    const pdfId = params.get('id');
    const BookId = params.get('BookId');
if (BookId) {
      this._svc.GET(API_End_Point.Chapter_Book_Wise(BookId))
           .subscribe((res) => {
             if (res.result === 'success') {
               this.ChapterList = res.data;
               if (this.ChapterList.length > 0) {
              this.loadChapter(0); // default: first chapter load
            }
             } else {
               this.ChapterList = res.data || [];
               this._svc.Notification('error', res.message || 'Something went wrong while fetching your orders.');
             }
           });
    }


    
    if (!pdfId) {
      this._svc.Notification('error', 'No PDF file found in the URL parameters.');
      return;
    }
    this.BookName = params.get('BookName') || 'E-Book';
    this.path = this._svc.getPdfUrl(pdfId);
    this.chapters = [{ title: 'Chapter', url: this.path }];
    this.selectedPdf = this.path;
  });
}

loadChapter(index: number) {
    this.activeChapterIndex = index;
    const chapter = this.ChapterList[index];
    const url = chapter.Chapter_FlipBook || chapter.ChapterPDF;

    if (url) {
      // 🔹 DomSanitizer se URL ko safe bana do
      this.selectedChapterUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      this.selectedChapterUrl = null;
    }
  }
  disableRightClick(event: MouseEvent) {
    event.preventDefault();
  }
  loadPDF(index: number): void {
    this.activeChapterIndex = index;
    this.selectedPdf = this.chapters[index].url;
  }
  
  @HostListener('window:resize')
  onResize() {
    this.detectScreenWidth();
  }
  detectScreenWidth() {
    const width = window.innerWidth;

    if (width <= PdfBreakpoints.xs) {
      this.zoom = 'auto';
      this.pageViewMode = 'none';
    } else if (width <= PdfBreakpoints.sm) {
      this.zoom = 'auto';
      this.pageViewMode = 'none';
    } else {
      this.zoom = 'page-fit';
      this.pageViewMode = 'book';
    }
  }




}
